module.exports = __webpack_public_path__ + "static/img/1.97b7072.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/eng/1.png
// module id = lRHw
// module chunks = 0